'use strict';

/**
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');

var template = require('modules/community/templates/layout/restriction-modal.hbs');

var RestrictionModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        actionProfile: '.modal-body a',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.actionProfile': 'actionGotoProfile',
    },

    actionClose: function(event) {
        this.trigger('close:modal', 'dashboard');
    },

    actionGotoProfile: function(event) {
        event.preventDefault();
        this.trigger('close:modal', $(event.currentTarget).attr('href'));
    },
});

module.exports = RestrictionModalView;